export default __webpack_public_path__ + "static/media/a017-market-2.776b425e.svg";